function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
/**
 * Logo - [API](https://scl.sharp.com/?path=/docs/base-logo) | [DSM](https://sharphealthcare.notion.site/Logo-7553dc94e29c475ba65afc8933413518)
 */ const Logo = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { variant = 'full', color = 'brand', 'aria-label': ariaLabel = 'Home' } = _param, props = _object_without_properties(_param, [
        "variant",
        "color",
        'aria-label'
    ]);
    if (variant === 'full') {
        return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 288 93.66",
            ref: ref,
            "aria-label": ariaLabel
        }, props), {
            children: [
                /*#__PURE__*/ _jsx("path", {
                    fill: color === 'brand' ? '#ffb71b' : 'currentColor',
                    d: "M.98 0H288v11.4H.98z"
                }),
                /*#__PURE__*/ _jsx("path", {
                    fill: color === 'brand' ? '#003b71' : 'currentColor',
                    d: "M25.53,51.58c-6.23-2.12-13.85-6.26-13.44-13.92,.5-9.31,11.22-13.05,18.67-9.18,7.52,3.91,8.88,12.38,8.86,12.38h5.38v-12.53s-8.37-5.91-15.8-7.25c-5.72-1.03-11.76-.52-17.08,1.92-3.53,1.61-6.26,3.88-8.21,6.81-1.95,2.92-2.92,6.34-2.92,10.25,0,5.56,1.82,10.13,5.44,13.72,3.63,3.59,8.97,6.97,16.02,9.01,4.1,1.39,9.13,3.2,11.61,7.03,4.31,6.63-.98,14.22-7.66,16.52-5.96,2.05-12.81-.18-16.94-4.81-1.42-1.59-2.57-3.45-3.37-5.43-.06-.14-.93-2.72-.71-2.72H0v12.53c3.6,2.78,7.3,4.77,11.11,5.96,3.81,1.2,7.93,1.79,12.36,1.79,4.73,0,8.86-.81,12.38-2.42,3.53-1.61,6.26-3.88,8.21-6.81,1.95-2.92,2.92-6.34,2.92-10.25,0-5.56-1.81-10.13-5.44-13.72-3.62-3.58-8.96-6.85-16.01-8.88h0Zm238.19-28.99l-31.36,.06v4.73c3.92,0,7.09,3.38,7.09,7.55v44.66c0,2.97-.72,6.75-3.49,6.75-3.79,0-16.89-20.96-20.42-26.72,7.33-1.33,14.47-5.44,14.47-18.17,0-18.75-19.2-18.86-24.27-18.86h-31.36v4.73c3.92,0,7.09,3.38,7.09,7.55l.04,44.62s.13,3.86-2.76,5.97c-1.65,1.2-3.44,.92-4.56-.46-.77-.95-1.55-2.29-2.35-4.15l-21.57-58.26h-11.14l-21.57,58.26c-.8,1.86-1.59,3.2-2.35,4.15-1.12,1.39-2.91,1.66-4.56,.46-2.89-2.11-2.76-5.97-2.76-5.97l.04-44.62c0-4.17,3.18-7.55,7.09-7.55v-4.73h-25.44v4.73c3.92,0,7.09,3.38,7.09,7.55v18.08h-30.4v-18.08c0-4.17,3.18-7.55,7.09-7.55v-4.73h-25.44v4.73c3.92,0,7.09,3.38,7.09,7.55v44.62c0,4.17-3.17,7.55-7.09,7.55v4.73h25.44v-4.73c-3.92,0-7.09-3.38-7.09-7.55v-19.23h30.4v19.23c0,4.17-3.17,7.55-7.09,7.55v4.7l-.05,.03h44.8v-4.73c-4.07,0-6.12-3.38-4.57-7.55l4.21-11.92h21.45l4.21,11.92c1.55,4.17-.5,7.55-4.58,7.55v4.73h45.91v-4.62c-3.92,0-7.09-3.38-7.09-7.55v-19.35h8.46l20.13,31.52h36.49v-4.62c-3.92,0-7.09-3.38-7.09-7.55v-19.35h11.86c8.78,0,24.28-.06,24.28-18.81s-19.2-18.85-24.28-18.85h0Zm-127.14,37.67l8.15-23.09,8.15,23.09h-16.3Zm69.01-7.31h-11.7V29.89h11.7c4.17,0,12.51,1.02,12.51,11.46s-8.34,11.6-12.51,11.6Zm57.97,0h-11.7V29.9h11.7c4.17,0,12.51,1.02,12.51,11.46s-8.34,11.6-12.51,11.6Z"
                })
            ]
        }));
    }
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ref: ref,
        "aria-label": ariaLabel
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: color === 'brand' ? '#ffb71b' : 'currentColor',
                d: "M8.63 1h15.05v3.65H8.63z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: color === 'brand' ? '#003b71' : 'currentColor',
                d: "M16.49 17.52c-2-.68-4.44-2.01-4.3-4.46.16-2.98 3.59-4.18 5.98-2.94 2.41 1.25 2.84 3.97 2.84 3.97h1.72v-4.01s-2.68-1.89-5.06-2.32c-1.83-.33-3.77-.17-5.47.61-1.13.52-2.01 1.25-2.63 2.18-.62.94-.94 2.03-.94 3.28 0 1.78.58 3.24 1.75 4.39 1.16 1.15 2.87 2.23 5.13 2.89 1.31.45 2.92 1.02 3.72 2.25 1.38 2.12-.31 4.55-2.45 5.29-1.91.66-4.1-.06-5.43-1.54-.45-.51-.82-1.11-1.08-1.74-.02-.04-.3-.87-.23-.87H8.31v4.01c1.15.89 2.34 1.53 3.56 1.91 1.22.38 2.54.57 3.96.57 1.52 0 2.84-.26 3.97-.78 1.13-.52 2.01-1.25 2.63-2.18.62-.94.94-2.03.94-3.28 0-1.78-.58-3.24-1.74-4.39-1.16-1.15-2.87-2.19-5.13-2.85Z"
            })
        ]
    }));
});
export { Logo };
